<template>
  <div style="width:100%;">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
      </div>
    </div>
    <div style="padding-top: 50px;height: calc(100vh - 30px) ">
      <iframe width="100%" height="500px" :src="`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(docx)}`" />
<!--            <iframe width="100%" height="100%" :src="`https://view.xdocin.com/view?src=${encodeURIComponent(docx)}`" />-->
<!--      <a style="display:inline-block;width: 110px;height: 30px;background-color: #1989fa;color: #fff;font-size: 12px;text-align: center;line-height: 30px;text-decoration: none" href="`https://view.officeapps.live.com/op/view.aspx?src=https://jinqiao-wuye.oss-cn-shanghai.aliyuncs.com/upload/2024/03/13/9892f8c6c1864a59b0c4117eae8f6b9a.docx`"-->
<!--         target="_blank"-->
<!--         rel="nofollow">-->
<!--        查看合同正文office-->
<!--      </a>-->
<!--      <a style="display:inline-block;width: 110px;height: 30px;background-color: #1989fa;color: #fff;font-size: 12px;text-align: center;line-height: 30px;text-decoration: none" href="`https://view.xdocin.com/view?src=https://jinqiao-wuye.oss-cn-shanghai.aliyuncs.com/upload/2024/03/13/9892f8c6c1864a59b0c4117eae8f6b9a.docx`"-->
<!--         target="_blank"-->
<!--         rel="nofollow">-->
<!--        查看合同正文xdoc-->
<!--      </a>-->
<!--      <a style="display:inline-block;width: 110px;height: 30px;background-color: #1989fa;color: #fff;font-size: 12px;text-align: center;line-height: 30px;text-decoration: none" href="`https://pfile.com.cn/api/profile/onlinePreview?url=https://jinqiao-wuye.oss-cn-shanghai.aliyuncs.com/upload/2024/03/13/9892f8c6c1864a59b0c4117eae8f6b9a.docx`"-->
<!--         target="_blank"-->
<!--         rel="nofollow">-->
<!--        查看合同正文pfile-->
<!--      </a>-->
<!--      <a style="display:inline-block;width: 110px;height: 30px;background-color: #1989fa;color: #fff;font-size: 12px;text-align: center;line-height: 30px;text-decoration: none" href="`https://ow365.cn/?i=33396&ssl=1&furl=https://jinqiao-wuye.oss-cn-shanghai.aliyuncs.com/upload/2024/03/13/9892f8c6c1864a59b0c4117eae8f6b9a.docx`"-->
<!--         target="_blank"-->
<!--         rel="nofollow">-->
<!--        查看合同正文officeweb365-->
<!--      </a>-->
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      docx: "",
    }
  },
  mounted() {
  },
  created() {
    this.$nextTick(() => {
      let query = this.$route.query;
      this.docx = query.url
    });
  },
  methods: {
    init() {
    },
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>
<!--<style scoped>-->
<!--button {-->
<!--  margin: 0 12px;-->
<!--  padding: 4px 8px;-->
<!--  margin-bottom: 12px;-->
<!--}-->

<!--iframe {-->
<!--  width: 900px;-->
<!--  height: 600px;-->
<!--}-->
<!--</style>-->


